import React from 'react';
import { ReactComponent as FigBriefcase01Component } from './FigBriefcase01.svg';

const FigBriefcase01 = (props) => <FigBriefcase01Component {...props} />;

export default FigBriefcase01;
